import { useGetSiteCurtailmentObjectsQuery } from "../../../../requests_cm/gecoSitesService/service";
import { useRtkQueryDynamicEndpoint } from "../../../../common/hooks/useRtkQueryDynamicEndpoint";
import CurtailmentObjects from "../../../../common/components/CurtailmentObjects";
import { Box, CircularProgress } from "@mui/material";
import NoDataMessage from "../../../../common/components/NoDataMessage";
import { CurtailmentKindFilter } from "../../../../common/components/CurtailmentObjects/CurtailmentKindFilter";
import { useCurtailementObjectsFilters } from "../../../../common/hooks/useCurtailementObjectsFilters";
import { If } from "../../../../common/components/If";

const CurtailmentObjectsTab = ({ siteId }: { siteId: number }) => {
	const { data, isLoading } = useRtkQueryDynamicEndpoint(
		useGetSiteCurtailmentObjectsQuery
	)({ siteId });

	const {
		curtailementObjectsGroupsBySites,
		filterByKinds,
		updateFilterByKinds,
	} = useCurtailementObjectsFilters(data);

	return (
		<>
			{isLoading && <CircularProgress />}
			{!isLoading && (
				<>
					{!data?.length && <NoDataMessage />}
					{!!data?.length && (
						<>
							<CurtailmentKindFilter
								curtailementKinds={filterByKinds}
								onChange={updateFilterByKinds}
							/>
							<If
								condition={
									curtailementObjectsGroupsBySites.length > 0
								}
							>
								<CurtailmentObjects
									curtailmentObjectGroup={
										curtailementObjectsGroupsBySites[0]
									}
								/>
							</If>
						</>
					)}
				</>
			)}
		</>
	);
};

export default CurtailmentObjectsTab;
